export const ApiRoutes = {
  auth: {
    check_email: "/auth/email/check", // API-A8
    login: "/auth/basic/login", // API-A1
    logout: "/auth/logout", // API-A7
    passkey_challenge_register: "/auth/passkey/register/challenge", // API-A9
    passkey_challenge_login: "/auth/passkey/login/challenge", // API-A10
    passkey_login: "/auth/passkey/login", // API-A6
    passkey_register: "/auth/passkey/register", // API-A3
    send_otp: "/auth/basic/otp", // API-A11
    send_email_otp: "/auth/basic/email/otp", // API-A11
    check_activation: "/auth/activation/check", // API-A4
    send_activation_otp: "/auth/activation/otp", // API-A12
    update_credentials: "/auth/activation/update", // API-A5
    verify: "/auth/basic/verify", // API-A2
    email_verify: "/auth/basic/email/verify", // API-A2
    token_login: "/auth/token/login", // API-D3
  },
  account: {
    detail: "/accounts/{accountId}", // API-B11
    edit: "/accounts/{accountId}", // API-B12
    list: "/accounts?sort_key={sort_key}&sort_order={sort_order}", // API-B9
    register: "/accounts", // API-B10
    reset_password: "/accounts/password/reset", // API-B14
    update_password: "/accounts/password/update", // API-B15
  },
  customer: {
    detail: "/customers/{customerId}", // API-B3
    edit: "/customers/{customerId}", // API-B4
    list: "/customers?sort_key={sort_key}&sort_order={sort_order}", // API-B1
    register: "/customers", // API-B2
  },
  file: {
    upload: "/files/upload", // API-C1
    result:
      "/files/result?mode={mode}&upload_result_id={upload_result_id}&file_name={file_name}&user_id={user_id}&menu_id={menu_id}&template_id={template_id}&date_from={date_from}&date_to={date_to}&result={result}&sort_key={sort_key}&sort_order={sort_order}&page={page}&size={size}", // API-C2
    delete: "/files/delete", // API-C3
    download: "/files/download", // API-C4
    templates: "/templates?menu_id={menu_id}", // API-C5
    user_list: "/accounts?sort_key={sort_key}&sort_order={sort_order}", // API-C6
    menu: "/data/menu.json", // Menu JSON file
    registration_results: "/data/registration_results.json", // Registration result JSON file
  },
  group: {
    detail: "/groups/{groupId}", // API-BX
    edit: "/groups/{groupId}", // API-B8
    list: "/groups?sort_key={sort_key}&sort_order={sort_order}", // API-B5
    register: "/groups", // API-B6
  },
  system: {
    list: "/systems", // API-BX
  },
  maintenance: "/data/maintenance.json", // Maintenance JSON file
};
